module.exports = __webpack_public_path__ + "img/weixin_mask_android.9d6979d8.png";